import React from "react";
import { useNavigate } from "react-router";
import { CardContainer } from "pages/Utilities/styles";

function UtilityCard({ url, title, subtitle, disabled }) {
  const navigate = useNavigate();
  return (
    <CardContainer
      disabled={disabled}
      onClick={() => {
        navigate(url);
      }}
    >
      <h2>{title}</h2>
      <p>{subtitle}</p>
    </CardContainer>
  );
}

export default UtilityCard;
